export const theme = {
  colors: {
    primary: '#00C4FF',
    textPrimary: '#FFFFFF',
    textSecondary: '#0000007A',
    backgroundPrimary: '#0C182C',
    backgroundSecondary: '#242F41',
    white: '#FFFFFF',
    black: '#000000',
    grey: '#7B7B7B',
    error: '#FF5C60',
    success: '#40D988',
    warning: '#FFCC65'
  }
} as const;

export type Theme = typeof theme;
